module.exports = __webpack_public_path__ + "static/media/golf-outing.e88b0f9e.jpg";